import { TableHead, TableRow } from '@ria-client/tw-shadcn/components/table';
import { DisclosureTooltip } from '@ria-client/tw-shared-ui';
import { CircleHelp } from 'lucide-react';

export interface SummaryTableHeadProps {
  headings: { label?: string; labelTooltip?: string }[];
}

const CELL_CLASS =
  'border-x-0 border-t-0 border-b border-border bg-transparent p-1 pt-0 text-left typography-text-small first:pl-0 md:typography-text-bold [&:not(:first-child)]:border-l-0';

export function SummaryTableHead({ headings }: SummaryTableHeadProps) {
  return (
    <TableRow>
      {headings.map(heading => (
        <TableHead className={CELL_CLASS} key={heading.label}>
          {heading.label}
          {heading.labelTooltip ? (
            <span className="inline whitespace-nowrap">
              {' '}
              <DisclosureTooltip
                trigger={
                  <button aria-label={heading.label ?? 'info'} type="button">
                    <CircleHelp aria-hidden />
                  </button>
                }
              >
                <span className="typography-text-small">{heading.labelTooltip}</span>
              </DisclosureTooltip>
            </span>
          ) : null}
        </TableHead>
      ))}
      <TableHead className={`${CELL_CLASS} hidden md:table-cell`}>Learn more</TableHead>
    </TableRow>
  );
}
